import { Injectable } from '@angular/core';
import { PublicProductCompositePaymentPeriod } from '../enums/public-product-composite-payment-period';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class PublicProductCompositePaymentPeriodProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<PublicProductCompositePaymentPeriod, string>([
    [PublicProductCompositePaymentPeriod.Monthly, 'miesiąc'],
    [PublicProductCompositePaymentPeriod.Once, 'jednorazowo'],
    [PublicProductCompositePaymentPeriod.PerMonth, 'miesiąc'],
  ]);

  public labelFor(
    period: PublicProductCompositePaymentPeriod,
  ): Observable<string> {
    const result = this.entries.get(period);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${period}" is not found.`,
      );
    }

    return of(result);
  }
}
